import { render, staticRenderFns } from "./YearPrice.vue?vue&type=template&id=4d2f1a80&scoped=true&"
var script = {}
import style0 from "./YearPrice.vue?vue&type=style&index=0&id=4d2f1a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f1a80",
  null
  
)

export default component.exports